import { ActivatedRoute } from '@angular/router';
import { Component, OnInit, AfterViewInit, ViewChild } from '@angular/core';
import { HttpClient, HttpHeaders } from "@angular/common/http";  
import { AppConfig } from './app.config';
import { CommonModule } from '@angular/common';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatExpansionModule } from '@angular/material/expansion';

// I.C.V. CarlosPaH Encriptación datos Ene 2026
import * as CryptoJS from 'crypto-js';

import { paramsSeguridad } from '../environments/environment'; 
const perfilUsuarioOFV = paramsSeguridad.perfilUsuario;
const tipoEmpleadorIdOFV = paramsSeguridad.tipoEmpleadorId;
const empleadorIdOFV = paramsSeguridad.empleadorId;
const tipoDocumentoIdOFV = paramsSeguridad.tipoDocumentoId;
const documentoIdOFV = paramsSeguridad.documentoId;
const claveOFV = paramsSeguridad.clave;
const aplicativoOFV = paramsSeguridad.aplicativo;
const origenOFV = paramsSeguridad.aplicativo;
// F.C.V. CarlosPaH Encriptación datos Ene 2026


@Component({
  selector: 'app-root',
  standalone: true,
  imports: [
    CommonModule,
    MatGridListModule,
    MatExpansionModule
  ],
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit, AfterViewInit {

  public _myPositionMaker;
  public _nombreEspecialidad;
  public _descripcionEspecialidad;
  public _resultProductos;
  public _resultSucursales;
  public _resultServicios;
  public _resultEspecialidades;
  public _resultDirectorioPAC;
  public _selectedProducto;
  public _selectedSucursal;
  public _selectedServicio;
  public _selectedEspecialidad;
  public _plan;
  public _Auth;
  public _Token;
  public _latitudActual = 4.324945965;
  public _longitudActual = -73.28768757;
  public _initialZoom;
  public _shouldFitBounds = false;
  public _zoom = 11;
  public _zoomMin = 18;
  public _previous;
  public _puntoInicial;
  public _puntoFinal;
  public _flagComoLlegar;
  
  zoom = 12;
  public _center: google.maps.LatLngLiteral = { lat: this._latitudActual, lng: this._longitudActual };
  mapOptions: google.maps.MapOptions = { 
    mapTypeId: 'roadmap', 
    zoomControl:true, 
    scrollwheel: true,
    mapId: 'AIzaSyDDWFa8xy2My9WWGYrtBVQZl1SYZhmDdeA'
  };

  selectedMarker: any = null;
  map!: google.maps.Map;
  directionsService!: google.maps.DirectionsService;
  directionsRenderer!: google.maps.DirectionsRenderer;
  infoWindow!: google.maps.InfoWindow;
  markers: any[] = [];
  
  constructor(private http: HttpClient, private activatedRoute: ActivatedRoute) {  
      // I.C.V. CarlosPaH Encriptación datos Ene 2026
          const perfilDc = this.decryptOfv(perfilUsuarioOFV);
          const tipoEmpIdDc = this.decryptOfv(tipoEmpleadorIdOFV);
          const EmpIdDc = this.decryptOfv(empleadorIdOFV);
          const tipoDocIdDc = this.decryptOfv(tipoDocumentoIdOFV);
          const DocIdDc = this.decryptOfv(documentoIdOFV);
          const claveDc = this.decryptOfv(claveOFV);
          const aplicativoDc = this.decryptOfv(aplicativoOFV);
          const origenDc = this.decryptOfv(origenOFV);
          
          if(this._Auth == undefined && this._Token == undefined){
            //Autenticación
            
              this.http.get(AppConfig.settings.apiURL.seguridad + "Login?PerfilUsuario="+ perfilDc +
                                                                  "&TipoEmpleadorId="+ tipoEmpIdDc + 
                                                                  "&EmpleadorId="+ EmpIdDc + 
                                                                  "&TipoDocumentoId="+ tipoDocIdDc + 
                                                                  "&DocumentoId="+ DocIdDc + 
                                                                  "&Clave="+ claveDc + 
                                                                  "&aplicativo="+ aplicativoDc ).subscribe(data => { this._Auth = data['Token'];
          
          // Token
          this.http.get(AppConfig.settings.apiURL.directorio + "Token?Token="+ this._Auth + "&Origen="+ origenDc).subscribe(data => { this._Token = data['token'];
          // F.C.V. CarlosPaH Encriptación datos Ene 2026  
            this.CargarLista(AppConfig.settings.apiURL.directorio + "ConsultaProducto", "Productos");
            this.CargarLista(AppConfig.settings.apiURL.directorio + "ServicioGeneral", "Servicios");                                      
          }, err => console.log(err)); 
        }, err => console.log(err));
      }else{
        this.CargarLista(AppConfig.settings.apiURL.directorio + "ConsultaProducto", "Productos");
        this.CargarLista(AppConfig.settings.apiURL.directorio + "ServicioGeneral", "Servicios");   
      }

      this.activatedRoute.queryParams.subscribe(params => {
        const _plan = params['plan'];
      });
   }

   async ngOnInit(): Promise<void> {
    this._shouldFitBounds = false;
    window.addEventListener("comollegar", (event: any) => {
      this.ComoLlegar(event.detail.lat, event.detail.lng);
    });
  }

  async ngAfterViewInit(): Promise<void> {
    await this.loadGoogleMaps();
    
    const { DirectionsRenderer, DirectionsService } = 
      await google.maps.importLibrary("routes") as google.maps.RoutesLibrary;
 
    const { Map, InfoWindow } = 
      await google.maps.importLibrary("maps") as google.maps.MapsLibrary;
 
    const { AdvancedMarkerElement } = 
      await google.maps.importLibrary("marker") as google.maps.MarkerLibrary;

    this.map = new Map(document.getElementById("map") as HTMLElement, {
      center: this._center,
      zoom: this._zoom,
      mapId: 'AIzaSyAzJNoY0aLRcpf0cD_-pGFoa3DisDNUeGY',
      zoomControl: true,
      scrollwheel: true
    });
    this.directionsService = new google.maps.DirectionsService();
    this.directionsRenderer = new google.maps.DirectionsRenderer();
    this.directionsRenderer.setMap(this.map);
    this.infoWindow = new InfoWindow();

    (window as any).AdvancedMarkerElement = AdvancedMarkerElement;

    this.CargarPuntoInicial();
  }
   
  private loadGoogleMaps(): Promise<void> {
    return new Promise((resolve, reject) => {
      if (window.google && window.google.maps && google.maps.importLibrary) {
        resolve();
        return;
      }
 
      const script = document.createElement('script');
      script.src = 'https://maps.googleapis.com/maps/api/js?key=AIzaSyDDWFa8xy2My9WWGYrtBVQZl1SYZhmDdeA&v=weekly&loading=async&libraries=maps,marker,routes';
      script.async = true;
      script.defer = true;
   
      script.onload = () => {
        const check = () => {
          if (google?.maps?.importLibrary) resolve();
          else setTimeout(check, 50);
        };
        check();
      };
   
      script.onerror = (err) => reject(err);
      document.head.appendChild(script);
    });
  }

  public CargarLista(_urlTipoLista, _tipoLista){
        const headers = new HttpHeaders({
          'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
          'Authorization': 'Bearer ' + this._Token
        })

        switch(_tipoLista) { 
          case "Productos": { 
            this.http.get(_urlTipoLista, {  headers: headers }).subscribe(data => {this._resultProductos = data;}, err => console.log(err));     
            break; 
          } 
          case "Sucursales": { 
            this.http.get(_urlTipoLista, {  headers: headers }).subscribe(data => {this._resultSucursales = data;}, err => console.log(err));     
            break; 
          }
          case "Servicios": { 
            this.http.get(_urlTipoLista, {  headers: headers }).subscribe(data => {this._resultServicios = data;}, err => console.log(err));     
            break; 
          }
          case "Especialidades": { 
            this.http.get(_urlTipoLista, {  headers: headers }).subscribe(data => {this._resultEspecialidades = data;}, err => console.log(err));     
            break; 
          
          }
          case "DirectorioPAC": { 
            this.http.get(_urlTipoLista, {  headers: headers }).subscribe((data: any[]) => {
              if(data.length > 0){
                this._resultDirectorioPAC = data; 
                this._resultDirectorioPAC.map(element => {
                  if (parseFloat(element.latitud) == 0 || parseFloat(element.longitud) == 0 || element.longitud == "" || element.latitud == "") {
                    element.latitud = 0;
                    element.longitud = 0;
                    return element;
                  }
                  if(typeof element.latitud === 'string' && !isNaN(Number(element.latitud))){
                    element.latitud = parseFloat(element.latitud);
                    element.longitud = parseFloat(element.longitud);
                    return element;
                  }
                });

                this._nombreEspecialidad = data[0].nombreEs; 
                this._descripcionEspecialidad = data[0].descripcionEs;
                this._shouldFitBounds = true;
                this.addMarkers();
              }else{
                alert('No se encontró información relacionada con los criterios de búsqueda.');
              }
              }, err => console.log(err));     
                
            break; 
          }
          default: { 
            //statements; 
            break; 
          } 
      }
  }

  addMarkers() {
    if (!this._resultDirectorioPAC?.length || !this.map) return;
   
    this.clearMarkers();
    const bounds = new google.maps.LatLngBounds();

   
    this._resultDirectorioPAC.forEach(marker => {
      const lat = Number(marker.latitud);
      const lng = Number(marker.longitud);
   
      if (!isNaN(lat) && !isNaN(lng)) {
        const advMarker = new (window as any).AdvancedMarkerElement({
          map: this.map,
          position: { lat, lng },
          title: marker.nombre
        });
   
        this.markers.push(advMarker);
        bounds.extend({ lat, lng });

        advMarker.addListener('gmp-click', () => {
          this.selectedMarker = marker;

          const content = `
              <div>
              <b>${marker.sede}</b><br/><br/>
              <strong>Teléfono:</strong> ${marker.telefono ?? 'N/A'}<br/><br/>
              <strong>Dirección:</strong> ${marker.direccion ?? 'N/A'}<br/><br/>
              <a href="#" onclick="window.dispatchEvent(new CustomEvent('comollegar', { detail: { lat: ${lat}, lng: ${lng} } }))">
                              ¿Cómo llegar?
              </a>
              </div>
            `;
   
          this.infoWindow.setContent(content);
          this.infoWindow.open(this.map, advMarker);
          
          this._previous = marker;
        });
      }
    });
    if (!bounds.isEmpty()) {
      this.map.fitBounds(bounds);
      const listener = google.maps.event.addListenerOnce(this.map, 'bounds_changed', () => {
        const currentZoom = this.map.getZoom()!;
        if (currentZoom > this._zoomMin) this.map.setZoom(this._zoomMin);
      });
    }
  }

  clearMarkers() {
    this.markers.forEach(m => (m.map = null));
    this.markers = [];
  }

  onChangeProductos(e) {
    let selectedText:string = e.target.options[e.target.options.selectedIndex].text;
    this._selectedProducto = e.target['value'];
    
    this._resultSucursales = null;
    this._resultServicios = null;
    this._resultEspecialidades = null;
    this._resultDirectorioPAC = null;
    this._nombreEspecialidad = "";
    this._descripcionEspecialidad = "";

    switch(selectedText.trim()){
      case "PLAN GAMA":
        this._plan = "gama";
        break;
      case "PLAN DELTA":
        this._plan = "delta";
        break;
      case "PLAN OMEGA":
        this._plan = "omega";
        break;
      case "PLAN ALFA":
        this._plan = "alfa";
        break;
    }

    this.CargarLista(AppConfig.settings.apiURL.directorio + "Sucursales?CodigoPro=" + e.target['value'], "Sucursales");
  }

  onChangeSucursales(e) {
    this._selectedSucursal = e.target['value'];

    this._resultServicios = null;
    this._resultEspecialidades = null;
    this._resultDirectorioPAC = null;
    this._nombreEspecialidad = "";
    this._descripcionEspecialidad = "";

    this.CargarLista(AppConfig.settings.apiURL.directorio + "ServicioGeneral?CodigoPro=" + this._selectedProducto + "&CodigoSu=" + this._selectedSucursal, "Servicios");
  }

  onChangeServicios(e) {
    this._selectedServicio = e.target['value'];

    this._resultEspecialidades = null;
    this._resultDirectorioPAC = null;
    this._nombreEspecialidad = "";
    this._descripcionEspecialidad = "";

    this.CargarLista(AppConfig.settings.apiURL.directorio + "Especialidad?CodigoPro=" + this._selectedProducto + "&CodigoSu=" + this._selectedSucursal + "&CodigoSG=" + this._selectedServicio, "Especialidades");
  }

  onChangeEspecialidades(e) {
    this._selectedEspecialidad = e.target['value'];

    this.CargarLista(AppConfig.settings.apiURL.directorio + "DirectorioPAC?CodigoPro=" + this._selectedProducto + "&CodigoSu=" + this._selectedSucursal + "&CodigoEs=" + this._selectedEspecialidad, "DirectorioPAC");
  }

  ComoLlegar(lat, lng){
    this.directionsRenderer.setDirections({ routes: [], geocoded_waypoints: [] } as unknown as google.maps.DirectionsResult);;
 
    const request: google.maps.DirectionsRequest = {
      origin: { lat: this._center.lat, lng: this._center.lng },
      destination: { lat: lat, lng: lng },
      travelMode: google.maps.TravelMode.DRIVING,
    };
 
    this.directionsService.route(request, (result, status) => {
      if (status === 'OK' && result) {
        this.directionsRenderer.setDirections(result);
      } else {
        console.error('Error obteniendo ruta:', status);
      }
    });

    this.infoWindow.close();
  }

  async CargarPuntoInicial(){
    const { AdvancedMarkerElement } = await google.maps.importLibrary("marker") as google.maps.MarkerLibrary;
    const { InfoWindow } = await google.maps.importLibrary("maps") as google.maps.MapsLibrary;
    // Uso justificado de geolocalizacion: Es para el correcto funcionamiento de la funcion de ruta desde el api de Google maps
    if (navigator.geolocation){
      navigator.geolocation.getCurrentPosition( pos => {
        this._latitudActual = pos.coords.latitude;
        this._longitudActual = pos.coords.longitude;  
        this._center = {
          lat: this._latitudActual,
          lng: this._longitudActual
        };
        this._resultDirectorioPAC = [
          {
            latitud: this._latitudActual,
            longitud: this._longitudActual,
            nombre: 'nodata'
          },
        ];
        this._puntoInicial = { lat: pos.coords.latitude, lng: pos.coords.longitude };
        this.createAdvancedMarkers(AdvancedMarkerElement, InfoWindow);
      });
    }
  }
  createAdvancedMarkers(AdvancedMarkerElement: any, InfoWindow: any) {
    const bounds = new google.maps.LatLngBounds();
    this._resultDirectorioPAC.forEach(marker => {
      const lat = Number(marker.latitud);
      const lng = Number(marker.longitud);
 
 
      const advMarker = new (window as any ).AdvancedMarkerElement({
        map: this.map,
        position: { lat, lng },
        title: marker.nombre,
      });
 
      this.markers.push(advMarker);
      bounds.extend({ lat, lng });
 
      advMarker.addListener('click', () => {
        this.selectedMarker = marker;
 
        const content = `<b>Usted está aquí</b>`;
 
        this.infoWindow.setContent(content);
        this.infoWindow.open(this.map, advMarker);
      });
    });
    if (!bounds.isEmpty()) {
      this.map.fitBounds(bounds);
      const listener = google.maps.event.addListenerOnce(this.map, 'bounds_changed', () => {
        const currentZoom = this.map.getZoom()!;
        if (currentZoom > this._zoom) this.map.setZoom(this._zoom);
      });
    }
  }

  // I.C.V. CarlosPaH Encriptación datos Ene 2026
    // Para desencriptar
    decryptOfv(data: string)
    {
      const clave = 'D1R3ct0r10P4C'; 
      const bytes = CryptoJS.AES.decrypt(data, clave);
      const textoDescifrado = bytes.toString(CryptoJS.enc.Utf8);
      return textoDescifrado.toString();
    }
    // F.C.V. CarlosPaH Encriptación datos Ene 2026
}
